/**
 * Returns true if enter or space is pressed else false
 *
 * @param {Event} e - key event object
 * @returns {boolean} - true/false
 */
const isEnterOrSpacePressed = e => {
    return e.key === ' ' || e.code === 'Space' || e.key === 'Enter' || e.code === 'Enter' || e.code === 'NumpadEnter';
};

export default isEnterOrSpacePressed;
